import React from 'react';
import Contact from '../components/Contact';

const ContactPage: React.FC = () => {
  return (
    <Contact />
  );
};

export default ContactPage;
//test
